import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { skipWhile } from 'rxjs/operators';

@Component({
	selector: 'flx-key-value-display-with-instructions',
	templateUrl: './key-value-display-with-instructions.component.html',
	styleUrls: ['./key-value-display-with-instructions.component.scss']
})
export class FLXKeyValueDisplayWithInstructionsComponent implements OnInit, OnDestroy {
	@Input() title: string;
	@Input() title$: Observable<any>;
	@Input() instructions: string[];
	@Input() keyValueList$: Observable<any>;
	@Input() headingConfig: any;

	private _subscription: Subscription;
	private _title: string;

	constructor() {}

	ngOnInit() {
		if (this.title$) {
			this._title = this.title;
			this._subscription = this.title$.pipe(skipWhile(x => !x)).subscribe(title => {
				this.title = this._title;
				this.title += this._title && this._title !== '' ? ' ' : '';
				this.title += title;
			});
		}
	}

	ngOnDestroy() {
		if (this._subscription) {
			this._subscription.unsubscribe();
		}
	}
}
